<div class="dm-settings-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'DOCUMENT_MANAGEMENT.SETTINGS.DESCRIPTION' | translate }}
    </p>

    @if (initialLoadFailed() && loadError(); as error) {
      <tf-settings-load-error
        [title]="error"
        [message]="'SETTINGS.LOAD_ERROR.MESSAGE' | translate"
        [details]="loadErrorDetails()"
        [retrying]="isLoading()"
        (retry)="retryLoad()" />
    } @else if (!hasLoadedOnce()) {
      <div class="dm-settings-skeleton" aria-hidden="true">
        <section class="dm-settings-skeleton__card">
          <span class="dm-settings-skeleton__bar dm-settings-skeleton__bar--title"></span>
          <span class="dm-settings-skeleton__bar dm-settings-skeleton__bar--text"></span>
          <span class="dm-settings-skeleton__bar dm-settings-skeleton__bar--text-short"></span>
          <div class="dm-settings-skeleton__field">
            <span class="dm-settings-skeleton__bar dm-settings-skeleton__bar--label"></span>
            <span class="dm-settings-skeleton__control"></span>
          </div>
          <span class="dm-settings-skeleton__note"></span>
        </section>
      </div>
    } @else {
      <div class="dm-settings-cards">
        <section class="dm-settings-card">
          <tf-settings-inline-message
            [message]="saveError()"
            messageId="dm-settings-retention-error"
            (dismissed)="clearSaveError()" />

          <div class="dm-settings-card__header">
            <h3 class="settings-page__section-title">
              {{ 'DOCUMENT_MANAGEMENT.AUTO_HARD_DELETE_LABEL' | translate }}
            </h3>
            <p class="settings-page__description">
              {{ 'DOCUMENT_MANAGEMENT.AUTO_HARD_DELETE_HINT' | translate }}
            </p>
          </div>

          <div class="form-group settings-page__field dm-settings-field">
            <label
              for="dm-settings-retention"
              class="settings-page__label dm-settings-field__label">
              {{ 'DOCUMENT_MANAGEMENT.AUTO_HARD_DELETE_FIELD_LABEL' | translate }}
            </label>
            <p-inputNumber
              inputId="dm-settings-retention"
              [ngModel]="autoHardDeleteAfterDays()"
              (ngModelChange)="onValueChange($event)"
              [min]="minRetention"
              [max]="maxRetention"
              [step]="1"
              [useGrouping]="false"
              [suffix]="' ' + ('DOCUMENT_MANAGEMENT.AUTO_HARD_DELETE_DAYS_SUFFIX' | translate)"
              [disabled]="!canEdit() || isSaving()"
              styleClass="dm-settings-field__input"
              inputStyleClass="dm-settings-field__input-control"
              [class.ng-invalid]="!!saveError()"
              [attr.aria-invalid]="saveError() ? true : null"
              [attr.aria-describedby]="saveError() ? 'dm-settings-retention-error' : null" />
          </div>

          <p-message severity="info" icon="pi pi-info-circle" styleClass="dm-settings-storage-note">
            {{ 'DOCUMENT_MANAGEMENT.STORAGE_NOTE' | translate: { days: autoHardDeleteAfterDays() } }}
          </p-message>
        </section>
      </div>
    }
  </div>

  @if (hasLoadedOnce() && !initialLoadFailed()) {
    <tf-settings-actions
      (cancelled)="onCancel()"
      (save)="onSave()"
      [disabled]="!canSave()"
      [loading]="isSaving()" />
  }
</div>
